export interface IGetCarrierByIdFiltersDto {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
